<template>
    <div class="form-group">
        <label v-if="label" :for="name">{{label}}</label>
        <textarea class="form-control" :id="name" :name="name" :rows="rows" :placeholder="placeholder"
            v-model="model[name]" :disabled="disabled"></textarea>
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            },

            rows: {
                type: Number,
                default: 10
            },

            disabled: {
                type: Boolean,
            }

        },

        computed: {
            placeholder() {
                if (this.label) {
                    return `${this.Lang.get('messages.enter')} ${this.label}`;
                }
            }
        }
    };

</script>

<style>
</style>
